import { useTranslation } from "@next-platform/client-common-core";
import { Size, Switch } from "@next-platform/client-common-spicy-ui";
import React from "react";

import { Row, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

type ConversationImagePersonaToggleProps = {
  isChecked: boolean;
  hasPersonaAvatar: boolean;
  onIncludePersonaChange: (isNewIncludePersona: boolean) => void;
};

/** "Include persona" switch; it needs a persona avatar to be enabled. */
const ConversationImagePersonaToggle = ({ isChecked, hasPersonaAvatar, onIncludePersonaChange }: ConversationImagePersonaToggleProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Row className="leading-5 pb-0">
        <Switch
          checked={isChecked}
          onCheckedChange={onIncludePersonaChange}
          disabled={!hasPersonaAvatar}
          label={t("chat:modal.imageSettings.includePersona.label")}
          size={Size.LARGE}
        />
      </Row>
      <Row>
        <Text variant={"smallest"}>
          {hasPersonaAvatar ? (
            <Trans i18nKey="chat:modal.imageSettings.includePersona.description" />
          ) : (
            <Trans i18nKey="chat:modal.imageSettings.includePersona.disabledHint" />
          )}
        </Text>
      </Row>
    </>
  );
};

export default React.memo(ConversationImagePersonaToggle);
